interface Source {
    [index: string]: any
}

export function DestructureObject(source: Source | null): any {
    if (source === null) return null

    const object: { [key: string]: any} = {}
    for (const key in source) {
        if (source.hasOwnProperty(key)) {
            let name = ""
            const complex = key.indexOf("_") !== -1
            if (complex) {
                name = key.split("_").reduce((acc, cur, index) => {
                    if (index === 0) {
                        return acc += cur
                    } else {
                        const [ first, ...rest ] = cur.split("")
                        return acc += (first.toUpperCase() + rest.join(""))
                    }
                }, "")
            } else {
                name = key
            }
            object[name] = source[key]
        }
    }
    return object
}
export const getUniqueKey = function guidGenerator() {
    const S4 = () => (((1 + Math.random()) * 0x10000)).toString(16).substring(1)
    return (`${S4() + S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`)
}
// 时间格式化
export const timeFormatStr = {
    whole: "YYYY年MM月DD日 HH:mm",
    all: "YYYY年MM月DD日",
    day: "DD dddd",
    month: "MM月DD日 dddd",
}
